import React from 'react';
import { View } from 'react-native';
import Svg, { Circle } from 'react-native-svg';

import { palette } from '@/config/theme';

/**
 * Conic-style progress ring (the Volt rating/chemistry ring) rendered with
 * SVG stroke dashes so it works identically on native and web.
 */
export function RatingRing({
  size,
  percent,
  strokeWidth = 3,
  color = palette.volt,
  children,
}: {
  size: number;
  /** 0..100 */
  percent: number;
  strokeWidth?: number;
  color?: string;
  children?: React.ReactNode;
}) {
  const clamped = Math.max(0, Math.min(100, percent));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const filled = (clamped / 100) * circumference;

  return (
    <View style={{ width: size, height: size, alignItems: 'center', justifyContent: 'center' }}>
      <Svg
        width={size}
        height={size}
        style={{ position: 'absolute', transform: [{ rotate: '-90deg' }] }}
      >
        <Circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="rgba(255,255,255,0.15)"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <Circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={`${filled} ${circumference - filled}`}
          strokeLinecap="round"
        />
      </Svg>
      {children}
    </View>
  );
}
